import * as Styles from './events.styles';
import React from 'react';

export const Events: React.FC = () => {
    return (
      <Styles.EventsContainer>
        <Styles.Section>
          <Styles.Heading>Events and Meetup Group</Styles.Heading>
          <Styles.Text>
            Once you're a member of the London Rust Project Group, you can apply to join our
            official Meetup group using the same email address you applied for membership
            with, and your request will be promptly approved.
          </Styles.Text>
        </Styles.Section>
  
        <Styles.Section>
          <Styles.Heading>Zoom Talks</Styles.Heading>
          <Styles.Text>
            We are committed to sharing knowledge and engaging with the wider community.
            All Zoom talks hosted by the London Rust Project Group will be open to everyone, 
            regardless of membership status. Stay tuned for upcoming events!
          </Styles.Text>
        </Styles.Section>
  
        <Styles.MeetupButton
          href="https://www.meetup.com/london-rust-project-group/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join Our Meetup Group
        </Styles.MeetupButton>
      </Styles.EventsContainer>
    );
  };
